import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// core components
import { NavPills } from '@totalsoft/rocket-ui';

// material-ui-icons
import Dashboard from '@mui/icons-material/Dashboard';
import Schedule from '@mui/icons-material/Schedule';
import Ballot from '@mui/icons-material/Ballot';

//inner components
import DocumentScoringCategoryListContainer from './DocumentScoringCategoryListContainer';
import DocumentScoringIndicatorListContainer from './DocumentScoringIndicatorListContainer';
import DocumentScoringAttributeListComponent from './DocumentScoringAttributeListComponent';

export const DocumentScoringClassificationComponent = ({
  documentId,
  siteId,
  documentScoringGridId,
  engineScoringId,
  scoringClassification,
  indicatorPeriodList,
  disabled,
  entityType,
  isHistory,
  viewScoringDetailLimits,
  scoringGridCategoryScoreRead
}) => {
  const { t } = useTranslation();
  let tabsArray = [];

  if (scoringClassification.categories.length > 0) {
    tabsArray.push({
      label: t('DocumentEdit.Scoring.ScoringClassification.Categories'),
      icon: <Dashboard />,
      content: (
        <DocumentScoringCategoryListContainer
          documentId={documentId}
          siteId={siteId}
          documentScoringGridId={documentScoringGridId}
          scoringClassificationId={scoringClassification.scoringClassificationId}
          categoryList={scoringClassification.categories}
          disabled={disabled}
          entityType={entityType}
          isHistory={isHistory}
          viewScoringDetailLimits={viewScoringDetailLimits}
          scoringGridCategoryScoreRead={scoringGridCategoryScoreRead}
        />
      )
    });
  }

  if (scoringClassification.financialIndicators.length > 0) {
    tabsArray.push({
      label: t('DocumentEdit.Scoring.ScoringClassification.Indicators'),
      icon: <Schedule />,
      content: (
        <DocumentScoringIndicatorListContainer
          indicatorList={scoringClassification.financialIndicators || []}
          scoringClassificationId={scoringClassification.scoringClassificationId}
          periodList={indicatorPeriodList}
          documentId={documentId}
          siteId={siteId}
          documentScoringGridId={documentScoringGridId}
          engineScoringId={engineScoringId}
          disabled={disabled}
          entityType={entityType}
          isHistory={isHistory}
        />
      )
    });
  }

  if (scoringClassification.attributes.length > 0) {
    tabsArray.push({
      label: t('DocumentEdit.Scoring.ScoringClassification.Attributes'),
      icon: <Ballot />,
      content: <DocumentScoringAttributeListComponent attributeList={scoringClassification.attributes} />
    });
  }

  return <NavPills orientation='vertical' tabPanelProps={{ sx: { width: '100%' } }} tabs={tabsArray} />;
};

DocumentScoringClassificationComponent.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  documentScoringGridId: PropTypes.number,
  engineScoringId: PropTypes.number,
  scoringClassification: PropTypes.object.isRequired,
  indicatorPeriodList: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  entityType: PropTypes.string.isRequired,
  isHistory: PropTypes.bool,
  viewScoringDetailLimits: PropTypes.bool.isRequired,
  scoringGridCategoryScoreRead: PropTypes.bool.isRequired
};

export default DocumentScoringClassificationComponent;
